import { TagsResponse } from '@/interfaces/http-response/get-all-tags-with-locale';
import Tag from '@/models/tag';

export class TagsAdapter {
  static adapt(data: Tag): Tag {
    return new Tag(data);
  }
}
